<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <h1 class="text-xs-left my-3 ml-3">Рейтинг агентов</h1>
    <v-layout row class="ml-3">
      <v-flex xs12 v-if="$store.getters.user !== null">
        <v-layout row v-if="$store.getters.user.sale_group === null">
          <v-flex xs4 lg4 md4>
            <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                :return-value.sync="date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                class="mr-3"
            >
              <v-text-field
                  slot="activator"
                  v-model="dateFormatted"
                  label="Дата"
                  readonly
                  outline
              ></v-text-field>
              <v-date-picker
                  v-model="date"
                  @input="inputDate"
                  locale="ru"
                  :first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs4 lg4 md4 v-if="$store.getters.user.branch === null">
            <v-select
                :items="branchTitleList"
                label="Филиал"
                v-model="branch"
                class="mr-3"
                @input="onBranchSelect()"
                outline
                no-data-text="Нет данных"
            ></v-select>
          </v-flex>

          <v-flex xs4 lg4 md4 v-if="branch !== 'Все филиалы' && branch !== null">
            <v-select
                :items="saleGroupTitleList"
                label="Супервайзер"
                v-model="saleGroup"
                class="mr-3"
                @input="onSaleGroupSelect()"
                outline
                no-data-text="Нет данных"
            ></v-select>
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12>
        <div>
          <v-data-table
              :headers="headers"
              :items="agents"
              :loading="loading"
              hide-actions
              class="elevation-1"
              no-data-text="Не найдено ни одного агента"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                <v-avatar class="my-2">
                  <img :src="props.item.user.photo.url_resized">
                </v-avatar>
              </td>
              <td class="text-xs-left cursor-pointer" @click="$router.push('/agents/single/'+date+'/'+props.item.user.id + getParamsString)">{{ props.item.user.surname }} {{ props.item.user.first_name }} {{ props.item.user.patronymic }}</td>
              <td class="text-xs-left">{{ lastActivity(props.item.last_datetime) }}</td>
              <td class="text-xs-left">{{ indicatorFormatting(props.item.order_sum) }} ₽ / {{ indicatorFormatting(props.item.plan_sum) === '0' ? '-' : indicatorFormatting(props.item.plan_sum) + ' ₽'}}</td>
              <td class="text-xs-left">{{ indicatorFormatting(props.item.order_weight) }} кг / {{ indicatorFormatting(props.item.plan_weight) === '0' ? '-' : indicatorFormatting(props.item.plan_weight) + ' кг' }} </td>
              <td class="text-xs-left">{{ props.item.point_count }}</td>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
                v-if="pages > 1"
                v-model="page"
                :length="pages"
                @input="changePage()"
                :total-visible="7"
            ></v-pagination>
          </div>
        </div>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Рейтинг агентов'}
        ],
        pageDataReady: {
          isReady: false,
          branchList: false
        },
        date: null,
        dateFormatted: null,
        menu: false,
        branch: null,
        branchId: null,
        saleGroup: null,
        saleGroupId: null,
        page: 1,
        search: '',
        pagination: {},
        selected: [],
        headers: [
          { text: 'Фото', sortable: false, value: 'avatar' },
          { text: 'ФИО', sortable: false, value: 'name' },
          { text: 'Последняя активность', sortable: false, value: 'last_datetime' },
          { text: 'Выручка', sortable: false, value: 'receipts' },
          { text: 'Объем заказов', sortable: false, value: 'amount' },
          { text: 'План ТТ', sortable: false, value: 'point_count' }
        ],
        agents: [],
        getParamsString: ''
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.branchList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onBranchSelect () {
        if (this.branch !== null && this.branch !== 'Все филиалы') {
          for (let i = 0; i < this.branchList.length; i++) {
            if (this.branchList[i].title === this.branch) {
              this.branchId = this.branchList[i].id
              break
            }
          }
          this.$store.dispatch('getSaleGroupList', {branchId: this.branchId})
        } else {
          this.branchId = null
        }
        this.updateUrl()
      },
      onSaleGroupSelect () {
        if (this.saleGroup !== null && this.saleGroup !== 'Все супервайзеры') {
          for (let i = 0; i < this.saleGroupList.length; i++) {
            if (this.saleGroupList[i].title === this.saleGroup) {
              this.saleGroupId = this.saleGroupList[i].id
              break
            }
          }
        } else {
          this.saleGroupId = null
        }
        this.updateUrl()
      },
      changePage () {
        this.getAgentList()
      },
      inputDate () {
        this.$refs.menu.save(this.date)
        this.updateUrl()
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
      },
      getAgentList () {
        if (this.date !== null) {
          let data = {
            date: this.date + ' 00:00:00',
            branchId: this.branchId,
            saleGroupId: this.saleGroupId,
            offset: (this.page - 1) * 25,
            limit: 25
          }

          this.$store.dispatch('getAgentList', data)
        } else {
          return false
        }
      },
      lastActivity (dateTime) {
        if (dateTime !== null && typeof dateTime !== 'undefined') {
          let sec = (Date.now() - Date.parse(dateTime.replace(/\s/, 'T'))) / 1000
          let min = sec / 60
          let hour = min / 60
          let days = hour / 24

          if (min < 1) {
            return '1 минуты назад'
          } else if (min < 5) {
            return Math.round(min) + ' минуты назад'
          } else if (hour < 1) {
            return Math.round(min) + ' минут назад'
          } else if (hour < 5) {
            return Math.round(hour) + ' часа назад'
          } else if (days < 1) {
            return Math.round(hour) + ' часов назад'
          } else {
            let date = new Date(dateTime.replace(/\s/, 'T'))
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString().substring(0, 5)
          }
        } else {
          return 'Нет активности'
        }
      },
      indicatorFormatting (val) {
        val = Math.round(parseFloat(val)).toString()
        let result = ''
        let i = 0
        val.split('').reverse().forEach(function (char) {
          if (i === 3) {
            result += ' '
            i = 1
          } else {
            i++
          }
          result += char
        })
        result = result.split('').reverse().join('')
        return result
      },
      updateUrl () {
        let filter = ''
        if (this.date !== null) {
          filter += '?date=' + this.date
        }

        if (this.branchId !== null) {
          if (filter === '') {
            filter += '?branch_id=' + this.branchId
          } else {
            filter += '&branch_id=' + this.branchId
          }
        }

        if (this.saleGroupId !== null) {
          if (filter === '') {
            filter += '?sale_group_id=' + this.saleGroupId
          } else {
            filter += '&sale_group_id=' + this.saleGroupId
          }
        }

        this.$router.push('/agents/rating' + filter)
      },
      getParams () {
        let getParam = ''
        Object.keys(this.$route.query).forEach((item, i) => {
          getParam += i === 0 ? '?' + item + '=' + this.$route.query[item] : '&' + item + '=' + this.$route.query[item]
        })
        this.getParamsString = getParam
      }
    },
    computed: {
      agentList () {
        return this.$store.getters.agentList
      },
      branchTitleList () {
        return this.$store.getters.branchTitleList
      },
      saleGroupTitleList () {
        return this.$store.getters.saleGroupTitleList
      },
      branchList () {
        return this.$store.getters.branchList
      },
      saleGroupList () {
        return this.$store.getters.saleGroupList
      },
      loading () {
        return this.$store.getters.loading
      },
      pages () {
        let pages = this.totalCount / 25
        if ((pages ^ 0) !== pages) {
          pages = Math.floor(pages) + 1
        }
        return pages
      },
      totalCount () {
        return this.$store.getters.agentTotalCount
      }
    },
    updated () {
      this.getParams()
    },
    created () {
      this.getParams()

      this.$store.commit('setPageLoading', true)
      this.$store.commit('setPageTitle', 'Рейтинг агентов')
      this.$store.dispatch('getBranchList')
        .then(() => {
          this.pageDataReady.branchList = true
          this.pageDataStatus()
        })

      if (typeof this.$router.currentRoute.query.date !== 'undefined') {
        this.date = this.$router.currentRoute.query.date
      } else {
        const [day, month, year] = new Date().toLocaleDateString().split('.')
        this.date = `${year}-${month}-${day}`
      }
    },
    watch: {
      agentList (val) {
        this.agents = this.agentList
      },
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
        this.getAgentList()
      },
      branchId (val) {
        this.getAgentList()
      },
      saleGroupId (val) {
        this.getAgentList()
      },
      branchList (val) {
        if (typeof this.$router.currentRoute.query.branch_id !== 'undefined') {
          const currentBranch = this.branchList.find(item => item.id === parseInt(this.$router.currentRoute.query.branch_id))
          this.branch = currentBranch.title
          this.branchId = currentBranch.id
        }

        if (this.$store.getters.user.branch !== null && this.branchId === null) {
          this.branch = this.$store.getters.user.branch.title
          this.branchId = this.$store.getters.user.branch.id
          this.$store.dispatch('getSaleGroupList', {branchId: this.branchId})
        }
        if (this.$store.getters.user.sale_group !== null && this.saleGroupId === null) {
          this.saleGroup = this.$store.getters.user.sale_group.title
          this.saleGroupId = this.$store.getters.user.sale_group.id
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Agents/AgentRating.vue